import { NativeStackScreenProps } from "@react-navigation/native-stack";
import { Card, FlatActionList, Page } from "@towersystems/roam-common-native";
import { SettingsRootParamList } from "../../../../types";
import {
  CART_POSITION,
  useLocalSettingsProvider,
} from "../../../../utilities/local-settings";

export type SelectCartPositionScreenProps = NativeStackScreenProps<
  SettingsRootParamList,
  "SelectCartPositionScreen"
>;

export const SelectCartPositionScreen = ({
  navigation,
}: SelectCartPositionScreenProps) => {
  const { settings, setSetting } = useLocalSettingsProvider();

  const handleOnClick = (position: CART_POSITION) => {
    setSetting("cartPosition", position);
    navigation.goBack();
  };

  const cartPosition = settings.cartPosition || "right";
  return (
    <Page>
      <Card>
        <FlatActionList
          items={[
            {
              key: "cart_position_right",
              title: "Cart Position Right",
              subTitle: "Cart position on the right",
              selected: cartPosition == "right",
              onPress: () => handleOnClick("right"),
            },
            {
              key: "cart_position_left",
              title: "Cart Position Left",
              subTitle: "Cart position on the left",
              selected: cartPosition == "left",
              onPress: () => handleOnClick("left"),
            },
          ]}
        />
      </Card>
    </Page>
  );
};
